export enum SlaveEvent {
  GameOpen = 'Game.Open',
  GameClose = 'Game.Close',
  Click = 'click'
}

export enum GatewayEvent {
  SlaveEvent = 'Slave.Event',
  AnalyticsSend = 'Analytics.Send',
  DocumentChangeMeta = 'Document.ChangeMeta',
  DocumentChangeTitle = 'Document.ChangeTitle',
  RouterRouteChanged = 'Router.RouteChanged',
  UserLoginRequired = 'User.LoginRequired'
}

export enum GatewayEmitEvent {
  UserAuthorizationChanged = 'User.AuthorizationChanged',
  UserBalanceChanged = 'User.BalanceChanged',
  RouteChanged = 'Router.RouteChanged'
}

interface BaseSlaveEvent {
  action: string
  msgSender: string
  plugin: string
  slaveId: string
}

interface ClickEvent extends BaseSlaveEvent {
  event: SlaveEvent.Click
}

interface GameEvent extends BaseSlaveEvent {
  event: SlaveEvent.GameOpen | SlaveEvent.GameClose
  data: {
    game: Game
  }
}

interface Game {
  code: string
  demo: boolean
  id: number
  isLive: boolean
  isVaixEvent: boolean
  page: string
  position: number
  productDisplayId: string
  providerName: string
  swimLane: string
  title: string
}

export interface NotifyRouteChangedParams {
  params: {
    param1: 'all'
    param2: string
  }
}

interface AnalyticsContent {
  id: string
  value: {
    gameIds: string[]
    page: string
  }
}

export interface AnalyticsSendEvent extends BaseSlaveEvent {
  data: {
    content: AnalyticsContent[]
    params: {
      category: string
    }
    type: 'VaixImpressions'
  }
}

export type SlaveEventMessage = ClickEvent | GameEvent
